import { fromType } from "@src/store/helpers";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@src/store/store";
import { _selectMapSplitMinQuantity, _selectSelectedRowNames, _selectSelectedSectionNames } from "@src/store/map/mapSlice";
import { matchesFilterTokens, matchesSectionFilterTokens } from "@src/utils/sectionFilter.utils";

export interface GameTimeSale {
	id: string;
	saleDate: string;
	eventDate: string;
	section: string;
	row: string;
	fulfillmentMethod: string;
	payoutPerTicket: number;
	quantity: number;
}
const initialState = fromType<Array<GameTimeSale>>([]);

export const { thunk: getGametimeSales, slice: getGametimeSalesSlice } = getThunkAndSlice<
	{ eventId: number },
	typeof initialState
>({
	initialState,
	// Routed through the portal backend proxy, which forwards the portal JWT to internal-api.
	path: ({ eventId }) => `/api/Marketplace/GameTime/Event/${eventId}/Sales`,
	cacheId: "eventId",
});

const selectGametimeSalesData = (state: RootState) => state.marketplace.gameTime.soldListings;

export const selectAggregatedGametimeSales = createSelector(
	[selectGametimeSalesData, _selectSelectedSectionNames, _selectMapSplitMinQuantity, _selectSelectedRowNames],
	(gametimeSalesData, selectedSections, minQuantity, selectedRows) => {
		const filteredListings =
			gametimeSalesData.data
				?.filter((x) => {
					const isSectionIncluded = selectedSections.length > 0 ? matchesSectionFilterTokens(selectedSections, x.section, x.row) : true;
					const isRowIncluded = selectedRows.length > 0 ? matchesFilterTokens(selectedRows, x.row) : true;
					const isMinQuantityIncluded = !minQuantity || x.quantity >= +minQuantity;

					return isSectionIncluded && isRowIncluded && isMinQuantityIncluded;
				})
				.sort((a, b) => {
					const timeA = new Date(a.saleDate).getTime();
					const timeB = new Date(b.saleDate).getTime();
					return timeB - timeA;
				}) || [];

		return {
			gametimeSalesLoading: gametimeSalesData.loading,
			filteredGametimeSales: filteredListings,
			totalTicketsSold: filteredListings?.reduce((acc, x) => acc + x.quantity, 0),
		};
	},
);
